module.exports = __webpack_public_path__ + "img/Graph_Monthly_net_occupancy_rates_of_bed_places,_January_to_September_2014.670f9a14.png";